
import React from 'react'
import { Helmet } from 'react-helmet';
import { useState, useEffect, memo } from 'react'
import Modal from '../ui/modal/Modal'
import OerlayModal from '../ui/modal/OerlayModal'
import config from '../config/config'
import axios from '../config/axios';
import { useDispatch, useSelector } from 'react-redux';
import { useRef } from 'react'
import EditContextai from './EditContextai';
import EditLogo from './EditLogo';
import TopActionButtonai from './TopActionButtonAi';
import 'react-toastify/dist/ReactToastify.css';
import { addFaqAnswerFromScrapped, fetchContext, onAddCompanyOverview, onChangeSelectTemplate, addCompanyInfo,resetFaq } from '../features/appSlice';
import { useParams } from 'react-router-dom';
import PersonalizedDemoai from './playgroungdemo/PersonalizedDemoai';
import PreviewChatai from './chatbotpreview/PreviewChatai';
import { ToastContainer } from 'react-toastify';
import { demoFormAction, postDemoForm } from '../features/demoFormSlice';
import { toast } from 'react-toastify';
import ModalSignup from '../ui/modal/modalSignup';
import { useNavigate } from 'react-router-dom';
import Headerai from './Headerai';

import { OverlayTrigger } from 'react-bootstrap';
import { Tooltip } from 'react-bootstrap';
import { onGenerateShareUrl, postContext, addConversation } from '../features/appSlice';
import Footer from './Footer'

const options = [
  { id: 2, name: "Plumbing / HVAC" },
  { id: 3, name: "Dental" },
  { id: 4, name: "Legal" },
];

const AiboatVideoSection = () => {
  const inputUrlForm = useRef();
  const [showModal, setShowModal] = useState(false);
  const domainlist = ['dev.zyratalk.com', 'uat.zyratalk.com', 'www.zyratalk.com', 'zyratalk.com', 'http://localhost:3001/playground', , 'http://localhost:3001/playground', 'localhost'];
const sitedomain = domainlist.includes(window.location.hostname);
  const inputSetupForm = useRef();
  const urlsRef = useRef([]);
  const dispacth = useDispatch();
  const forceUpdateRef = useRef();
  // const history = useHistory();
  const navigate = useNavigate();
  const [webUrl, setwebUrl] = useState("");
  const [webUrlError, setwebUrlError] = useState("");
  const [answers, setAnswers] = useState([]);
  const state = useSelector((state) => state);
  const [faviconUrl, setFaviconUrl] = useState('');
  const [scrapped, setScraped] = useState('');
  const [valids, setValids] = useState('');
  const [validity, setValidity] = useState('');
  const [mesg, setMesg] = useState('');
  const [userurls, setUrls] = useState("");
  const [showOverLay, setShowOverLay] = useState(false);
  const [showOverLayBody, setShowOverLayBody] = useState('');
  const [showArrow, setShowArrow] = useState(false);
  const [index, setIndex] = useState(0);
  const [inputshowModal, setInputShowModal] = useState(false);
  const [responseUrlModal, setResponseUrlModal] = useState(false);
  const [responseUrlModalBody, setresponseUrlModalBody] = useState('');
  const [aimodalBody, setAiModalBody] = useState('');
  const [inputModalBody, setinputModalBody] = useState('');
  const [editedData, setEditedData] = useState('');

  const [aimodalHeader, setAiModalHeader] = useState('')
  const [inputModalHeader, setInputModalHeader] = useState('')
  const [dataUrl, setDataUrl] = useState('')
  const [responseUrlModalHeader, setresponseUrlModalHeader] = useState('');
  const [loading, setLoading] = useState(false);
  const [modalLoader, setmodalLoader] = useState(false);
  const [quetionShowModal, setQuestionShowModal] = useState(false);
  const [quetionShowModalBody, setQuestionShowModalBody] = useState(false);
  const [quetionShowModalHeader, setQuestionShowModalHeader] = useState('');
  const contextId = useParams();
  const [contextData, setcontextData] = useState({});
  const [defaultContext, setdefaultContext] = useState(null);
  const [defaultLoader, setdefaultLoader] = useState(true);
  const [showAskForModal, setshowAskForModal] = useState(false);
  const [modalBody, setmodalBody] = useState('');
  const [modalFooter, setmodalFooter] = useState('');
  const [modaltitle, setModalTitle] = useState('');
  const [registerFormModal, setRegisterFormModal] = useState(false);
  const [registerFormModalBody, setRegisterFormModalBody] = useState('');
  const [aiLastModal, setAiLastModal] = useState(false);
  const [aiLastModalBody, setAiLastModalBody] = useState('');
  const [aiLastModalHeader, setAiLastModalHeader] = useState('');
  const [showOverLayHeader, setShowOverLayHeader] = useState('');
  const WhiteLablevideoUrls=['tdmi.chat-dashboard.com','dexcomm.chat-dashboard.com'];

  const companyNameRef = useRef();
  const companyContactNumberRef = useRef();
  const companyUrlRef = useRef();
  const emailLeadRef = useRef();
  const phoneNumberToSendLeadRef = useRef();
  const websiteManagerNameRef = useRef();
  const websiteManagerEmailRef = useRef();
  const additionalNotesRef = useRef();
  const [clientIpAddress, setclientIpAddress] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [emailErrorSignup, setEmailErrorSignup] = useState('');
  const [nameError, setNameError] = useState('');
  const [inputError, setInputError] = useState('')
  const [inputError1, setInputError1] = useState('')

  const [selectedOptionValues, setSelectedOptionValues] = useState('');
  const conversationGoalRef = useRef();

  const dispatch = useDispatch();
  const [domain, setDomain] = useState('');
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [fetchUrlFailed1, setFetchUrlFailed1] = useState(false);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseData, setResponseData] = useState('');
  const [questions, setQuestions] = useState([]);
  const [closeDisabled, setcloseDisabled] = useState(false);
  const [fetchUrlMessage, setfetchUrlMessage] = useState(null);
  const [fetchUrlData, setfetchUrlData] = useState(null);
  const [fetchedUrlSuccess, setfetchedUrlSuccess] = useState(null);
  const [fetchUrlFailed, setFetchUrlFailed] = useState(null);
  const [createMediumLengthMessage, setcreateMediumLengthMessage] = useState('');
  const [createMediumLengthError, setcreateMediumLengthError] = useState('');
  const [urlObj1, setUrlObj1] = useState(null);
  const [attempts, setAttempts] = useState(0);
  const [dataSubmit, setDataSubmit] = useState(state?.app?.contextData?.conversation_goal)

  const [workEmail, setWorkEmail] = useState('');
  const [workEmailError, setWorkEmailError] = useState('');
  const [requestDemoloading, setRequestDemoloading] = useState(false);
  const [requestDemoButtonDisabled, setRequestDemoButtonDisabled] = useState(false);

  const results = questions?.data?.map((q, index) => ({ q, a: answers[index] ? answers[index] : '' }));
  function enableScroll() {
    document.body.style.overflow = 'scroll';
  }

  function disableScroll() {
    document.body.style.overflow = 'hidden';
  }
  const [companyNameDatas, setCompanyNameDatas] = useState('');
  const fetchCompanyLogo = async () => {
    try {
      const domain = !domainlist.includes(window.location.hostname) ? window.location.hostname : '';
      const formData = new FormData();
      formData.append('domain', 'https://' + domain);

      const response = await axios.post(`${config.baseurl}/newengage/public/api/getPartnerCompanyLogo`, formData);
      const data = response.data;
      console.log(data, 'companyLogoPath');

      setCompanyNameDatas(data.data?.company);
      setFaviconUrl(data.data?.reseller_logo);
    } catch (error) {
      console.error('Error fetching company logo:', error);
    }
  };

  useEffect(() => {

    fetchCompanyLogo();
  }, []);

  useEffect(() => {
    if (domain) {
      const data11 = `${config.baseurl}/assets/images/resellerLogo/${faviconUrl}`;
      changeFavicon(data11);

      const helmet = Helmet.peek();
      helmet?.link?.push({ rel: 'icon', type: 'image/x-icon', href: data11 });

      return () => {
        helmet.link = helmet?.link?.filter((link) => link?.rel !== 'icon');
      };
    }
  }, [domain, faviconUrl]);

  const changeFavicon = (faviconUrl) => {
    const head = document.head || document.getElementsByTagName('head')[0];
    const favicon = document.createElement('link');
    favicon.type = 'image/x-icon';
    favicon.rel = 'icon';
    favicon.href = `${config.baseurl}/assets/images/resellerLogo/${faviconUrl}`;

    // Remove existing favicon, if any
    const existingFavicon = head.querySelector('link[rel="icon"]');
    if (existingFavicon) {
      head.removeChild(existingFavicon);
    }

    head.appendChild(favicon);

  };

  console.log(companyNameDatas, companyNameDatas, 'companyNameDatas')
  useEffect(() => {
    console.log(companyNameDatas, 'companyNameDatas11')

    if (domain) {
      document.title = `${companyNameDatas} | Train the AI Specific to Your Company`;

    } else {
      document.title = "ZyraTalk's Playground | Train the AI Specific to Your Company";
    }


  }, [domain, companyNameDatas]);



  const errorSaveBody = (error) => {
    return (

      <div className='text-center'>
        {error.map((err, mapindexerror) => (
          <p style={{ color: '#343a40', fontSize: 16 }} key={mapindexerror.toString()} className='fw-bold text-center'>{err.message}</p>
        ))}
      </div>
    )
  }
  const errorSaveFooter = () => {
    return (
      <button
        type="button"
        className="yr-cancelbtn"
        data-dismiss="modal"
        onClick={closeModals}
      >
        <span>Close</span>
      </button>
    )
  }
  const saveConversation = () => {
    dispatch(addConversation(conversationGoalRef.current.value));

  }

  const onSavePlayground = async (type) => {
    let statedata = JSON.parse(JSON.stringify(state.app.contextData));

    const newYourFaq = [...statedata?.your_faq]


    let error = [];

    if (error.length) {
      setshowAskForModal(true);
      setModalTitle('Save Playground context');
      setmodalBody(errorSaveBody(error));
      setmodalFooter(errorSaveFooter());
      return;
    }
    if (state.app.isEmailValid) {
      setshowAskForModal(true);
      setModalTitle('Save Playground context');
      setmodalBody(errorSaveBody(error));
      setmodalFooter(errorSaveFooter());
      return;
    }

    // if (type === 'old') {
    //     statedata.playgroundId = state.app.playgroundId;
    // }
    let myform = document.getElementById("editlogoform");
    let formData = new FormData(myform);
    formData.append('about_us', JSON.stringify(statedata.about_us));
    formData.append('additonal_faq_context', statedata.additonal_faq_context);
    formData.append('business_categories', JSON.stringify(statedata.business_categories));
    formData.append('buttonColor', statedata.buttonColor);
    formData.append('buttonHeaderColor', statedata.buttonHeaderColor);
    formData.append('buttonTextColor', statedata.buttonTextColor);
    formData.append('company_information', JSON.stringify(statedata.company_information));
    formData.append('conversation_goal', statedata.conversation_goal.replace(/<br\/>/g, '\n'));
    formData.append('primaryColor', statedata.primaryColor);
    formData.append('secondaryColor', statedata.secondaryColor);
    formData.append('selectedTheme', statedata.selectedTheme);
    // formData.append('your_faq', JSON.stringify(statedata.your_faq));newYourFaq
    // if (results) {
    formData.append('your_faq', JSON.stringify(newYourFaq));
    // } else {
    //   formData.append('your_faq', JSON.stringify(statedata.your_faq));
    // }
    formData.append('zipcoderules', JSON.stringify(statedata.zipcoderules));
    formData.append('company_overview', statedata.company_overview);
    // formData.append('company_overview', statedata.company_overview || dataUrls || dataUrl);
    if (type === 'old') {
      formData.append('playgroundId', state.app.playgroundId);
      formData.append('playgroundUniqueId', state.app.playgroundUniqueId);
    }
    try {
      const response = await dispatch(postContext(formData));

      return response.payload; // Assuming the response contains the desired data field
    } catch (error) {
      // Handle error if necessary
      throw error; // Rethrow the error to propagate it up the call stack
    }
  }

  const handleOptionClick = (id) => {
    disableScroll();
    if (id == 1) {
      setShowModal(true);
      setAiModalBody(sendmodalBody());
      setAiModalHeader(headerfunction());
      return;
    }
    setShowModal(false);
    setAiModalBody('');
    setAiModalHeader(headerfunction());

  };
  const handleOption = () => {
    setShowModal(false);
    setInputShowModal(true);
    setinputModalBody(sendmodalBodyInput());
    setInputModalHeader(headerfunction());
    setmodalLoader(false)
    resetInputValue()
    setUrls(['']);
    inputUrlForm.current.reset();


  }
  const handleKeyDown1 = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      ShowFirstPopup(event);
      // inputUrlForm.current.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  };

  const ShowFirstPopup = (e) => {
    inputUrlForm.current.reset();
    conversationGoalRef.current.value=state?.app?.defaultconversation_goal.replace(/<br\/>/g, '\n');
    setFetchUrlFailed(false);
    setButtonDisabled(false);
    setcloseDisabled(false);
    setfetchUrlMessage(null);
    setFetchUrlFailed1(null);
    setfetchedUrlSuccess(false);
    setFetchUrlFailed1(null);
    setInputError('')
    setDataError("")
    setInputError1('')
    setAnswers([]);
    dispatch(resetFaq());
    setQuestions([]);
    
    if (webUrl.length == 0) {
      setwebUrlError("Please provide a valid URL. You likely need to add “https://” at the start of your URL.");
      return false;
    } else if (!urlRegex.test(webUrl)) {
      setwebUrlError('Please provide a valid URL. You likely need to add “https://” at the start of your URL.');
      return false;
    } else {

      setShowModal(false);
      setInputShowModal(true);
      setinputModalBody(sendmodalBodyInput());
      setInputModalHeader(headerfunction());
      setmodalLoader(false)
      resetInputValue()
      setUrls(webUrl);
      //inputUrlForm.current.reset();
      handleSubmit();

    }



  }
  const locationsRef = useRef(null);



  const handleLastBtnClick = () => {
    setTimeout(() => {
      if (locationsRef.current) {
        locationsRef.current.scrollIntoView({ behavior: 'smooth' });
        setShowArrow(true)
      }
    }, 300);
    document.getElementById('bodyy').style.overflow = "hidden";
  };

  const domaina = !domainlist.includes(window.location.hostname) ? window.location.hostname : config.baseurl;

  const [dataError, setDataError] = useState()
  const handleOptionQustion = (data) => {
    const showdata = { content: data };
    setInputShowModal(true);
    // setShowModal(false);
    setmodalLoader(true)
    const bodyData = `content=${encodeURIComponent(data)}`;

    fetch(`${config.baseurl}/newengage/public/api/getFiveQuestion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: bodyData
    })
      .then(response => response.json())
      .then(data => {
        setQuestions(data);

        if (data?.data.length <= 5) {
          setQuestionShowModal(true);
          setInputShowModal(false);
          setResponseUrlModal(false);
          setQuestionShowModalBody(sendmodalBodyQuestions(data));
          setInputShowModal(false);
          setQuestionShowModalHeader(headerfunction());
          setDataError('')
        } else {

          setDataError('Unable to get response please try again.')

          setResponseUrlModal(true)
          setQuestionShowModal(false);
        }

      })
      .catch(error => {
      })
      .finally(() => {
        setmodalLoader(false);
      });
  }
  const closeModal = () => {
    inputUrlForm.current.reset();
    setShowModal(false)
    setInputShowModal(false);
    setResponseUrlModal(false);
    setQuestionShowModal(false);
    setResponseUrlModal(false);
    setAiLastModal(false);
    setUrls("");
    setInputError('');
    enableScroll();
    setwebUrl("");
    setInputError("");

  }
  const handleCloseModal = () => {
    inputUrlForm.current.reset();
    setUrls("")
    setShowOverLay(false)
    document.getElementById('bodyy').style.overflow = "scroll";
    enableScroll()
    console.log('close')

  };

  const headerfunctions = () => {
    return (
      <>
        <button type="button" class="btn-close text-white" onClick={handleCloseModal} data-bs-dismiss="modal" aria-label="Close"></button>
        {/* <button type="button" className="close_btn" onClick={handleCloseModal} data-bs-dismiss="modal" aria-label="Close" >X</button> */}
      </>
    )
  }
  const sendOverlay = () => {

    return (
      <>
        {/* <div class="modal-body text-center"> */}
        {/* <span class="yr-close" onClick={handleCloseModal}> X </span> */}
        {/* <button type="button" class="btn-close text-white" data-bs-dismiss="modal" onClick={handleCloseModal} aria-label="Close"></button> */}
        <h2 class="fw-bold fs-5 p-lg-4 pt-lg-0" > You can start testing below!<br />If you want to add more context or updates to make your bot smarter,<br /> feel free to do so at the top of this page!<br /> Click anywhere to continue.</h2>

        {/* <h2 class="fw-bold fs-5 p-lg-4 pt-lg-0" >Answer some additional questions to make your bot even smarter! <br /><br />Want to update later? <br /> let’s start testing below!</h2> */}
        {/* </div> */}
        {/* <div class="white_arrow">
          <img src={`${process.env.PUBLIC_URL}/images/white_arrow.svg`} />

        </div> */}
      </>
    )
  }


  const headerfunction = () => {
    return (
      <>
        <button type="button" className="close_btn" data-bs-dismiss="modal" aria-label="Close" >X</button>
      </>
    )
  }
  const sendmodalBody = () => {


    return (
      <>

        <div className="tab-content">
          <div className="tab-panes" id="steps1">

            <h2 className="text-black fw-bold text-center font-50">Hi there
              <img src={`${process.env.PUBLIC_URL}/images/hand.svg`} className="d-inline-block hand_icon" alt="hand_icon" />
              .
              {/* My name is Zyra */}
              {/* <img src={`${process.env.PUBLIC_URL}/images/roboat.svg`} className="d-inline-block hand_icon" alt="hand_icon" />. */}
              <br /> Do you want to create a custom AI chat <br /> experience for your own website? I promise <br /> it will take a just few minutes!</h2>
            <div className="d-flex buttons_next justify-content-center mt-5">
              <button
                className="main_btns"
                data-bs-toggle="modal" data-bs-target="#exampleModal"
                style={domain ? {
                  backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                  color: state.app.contextData?.buttonTextColor
                } : null}
                type="button"
                onClick={() => handleOption()}
              >Let’s do it!
              </button>
              <select className="form-select select_form mt-1" aria-label="Default select example"
                value={state.app.selectTemplate}
                onChange={handleOptionChange}
              >
                {state.app.selectTemplateList && state.app.selectTemplateList.map((item) => (
                  <option
                    key={item.id}
                    value={item.value}
                    selected={item.selected}
                  >
                    {item.name}
                  </option>
                ))}
              </select>

            </div>
          </div>
        </div>
      </>
    )
  }

  useEffect(() => {

    setHasSubmitted(false);
  }, [webUrl]);
  useEffect(() => {

    setresponseUrlModalBody(showUrldata(dataUrl))



  }, [dataError, createMediumLengthMessage]);




  const handleSubmit = async (event) => {
    // event.preventDefault();
    let newurl = webUrl;
    console.log("newUrls1", urlRegex.test(newurl), newurl)
    setInputError("");
    setInputError1("");
    setDataError("");
    setFetchUrlFailed("");
    if (newurl.length == 0) {
      setInputError('Please provide url');
    }
    if (urlRegex.test(newurl) == true) {
      console.log("newUrls1", urlRegex.test(newurl), newurl)
      setInputError('Please provide valid url');
    } else {
      setInputError("");
    }

    if (newurl != "" && urlRegex.test(newurl)) {
      console.log("newUrls12")
      // let isInputNotBlank = false;
      // newUrls1.forEach((url) => {
      //   if (url !== '') {
      //     isInputNotBlank = true
      //   };
      // })
      // if (inputError && !isInputNotBlank) {
      //   return;
      // }
    setInputError('');
    setResponseUrlModal(false);
    setButtonDisabled(true);

    if (hasSubmitted && !isSubmitting && dataUrl) {
      setResponseUrlModal(true);
      setresponseUrlModalBody(showUrldata({ data: dataUrl }));
      setresponseUrlModalHeader(headerfunction());
      setmodalLoader(false);
      setButtonDisabled(false);
      setInputShowModal(false);

    } else {
      setIsSubmitting(true);
      setcloseDisabled(true);
        //setButtonDisabled(true);

        const users = newurl.length;
      const dataArray = [];
      setAttempts(0)

      try {
        const urlobj = [];
          if (newurl == '') {
          setFetchUrlFailed1(0);
          setButtonDisabled(false); // Added this line to enable the button
          console.log(buttonDisabled)
          } else if (newurl) {
          setfetchUrlMessage(0);
          setFetchUrlFailed(null);
          setfetchedUrlSuccess(null);

          axios.post('/newengage/public/api/scrappedDataNew', {
              'url': newurl
          }).then((res) => {
            console.log(res, 'res')
            if (res.status) {
              if (res.data.success == true) {
                  urlobj.push({ inputid: 0, url: newurl, data: res.data.data.ScrappedData });
                  // setfetchedUrlSuccess([0, 1, 2]);
                  setFetchUrlFailed1('');
                                setButtonDisabled(false);
                  // setResponseData(res.data.data.companyDetails)
                  //setResponseUrlModal(true);
                                setfetchUrlMessage(null);
                  dispacth(onAddCompanyOverview([res.data.data.ScrappedData]));

                  dispatch(addCompanyInfo([res.data.data.companyDetails, "scrappedData"]));

                  setresponseUrlModalHeader(headerfunction());
                  setmodalLoader(false);
                  //setButtonDisabled(false);

                  createMediumLengthContext(urlobj);


              } else {
                setFetchUrlFailed(0);
                setButtonDisabled(false);
                setcloseDisabled(false);
                  setfetchUrlMessage(null)

              }


            }
          }).catch((err) => {
            setFetchUrlFailed(0);
            setButtonDisabled(false);
            setcloseDisabled(false);
            setfetchUrlMessage(null);

          })
        }

      } catch (error) {
        console.log(error);
      } finally {

      }
    }
    }
  };


  console.log(responseData, 'responseData')


  // useEffect(() => {
  //   if (urlObj1) {

  //     setresponseUrlModalBody(showUrldata(dataUrl))

  //   }
  // }, [urlObj1, attempts]);

  const createMediumLengthContext = (data = null) => {
    console.log(urlObj1, data, 'urlobj11')
    data = data ? data : urlObj1
    console.log(data, 'datass')
    console.log(urlObj1, 'datassss')
    let allScrappedData = '';
    if (data?.length) {
      allScrappedData = data[0];
    }
    console.log(allScrappedData, 'allScrappedData')
    if (allScrappedData.data) {
      setfetchedUrlSuccess(null);
      console.log(allScrappedData.data, "fgf");
      setcreateMediumLengthMessage('Generating context about your company - this can take up to a minute');
      setTimeout(() => {
        setButtonDisabled(false);
        setResponseUrlModal(false)
        setShowModal(false)
        setcloseDisabled(false)
        setIsSubmitting(false);
        setcloseDisabled(false);
        setHasSubmitted(true);
        setValids('')
        setcreateMediumLengthMessage('');
        setInputShowModal(false);
        setfetchedUrlSuccess(null);
        setFetchUrlFailed(null);
        setDataUrl(allScrappedData.data);
        setShowModal(false)
        setInputShowModal(false);
        setResponseUrlModal(true);
        setresponseUrlModalBody(showUrldata(allScrappedData.data));
        setmodalLoader(false);
        setresponseUrlModalHeader(headerfunction());
        setAiLastModalBody(sendmodalBodyai(state.app.contextData.conversation_goal));
        setAiLastModalHeader(headerfunction());

        // dispacth(onAddCompanyOverview([allScrappedData.data, 'scrapped']));
        setcloseDisabled(false)
        setwebUrl("");
      }, 10);




      return true;
      axios.post('/newengage/public/api/combineContentToGetContent', {
        'content': allScrappedData
      }).then((res) => {
        if (res.data.success) {
          setButtonDisabled(false);
          setResponseUrlModal(false)
          setShowModal(false)
          setcloseDisabled(false)
          setIsSubmitting(false);
          setcloseDisabled(false);
          setHasSubmitted(true);
          setValids('')
          setcreateMediumLengthMessage('');
          setInputShowModal(false);
          setfetchUrlMessage(null);
          setfetchedUrlSuccess(null);
          setFetchUrlFailed(null);
          setDataUrl(res.data.data);
          setShowModal(false)
          setResponseUrlModal(true);
          setresponseUrlModalBody(showUrldata(res.data));
          setmodalLoader(false);
          setresponseUrlModalHeader(headerfunction());
          setAiLastModalBody(sendmodalBodyai(state.app.contextData.conversation_goal));
          setAiLastModalHeader(headerfunction());
          // setButtonDisabled(true);
          dispacth(onAddCompanyOverview([res.data.data, 'scrapped']));

        }
        console.log(res);
      }).catch((err) => {
        setcreateMediumLengthMessage('');
        // setcreateMediumLengthError('Something went wrong');
        setButtonDisabled(false);
        setcloseDisabled(false);
        console.log(err);
      })
    }
  }
  const inputRef = useRef(null);


  const urlRegex = /^(https?):\/\/(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*)(?::\d+)?(?:\/\S*)?$/;
  // const inputRefs = useRef([]);
  const handleUrlChange = (event, index) => {
    console.log(userurls)
    event.preventDefault();
    setButtonDisabled(false);
    setcloseDisabled(false);
    const url = event.target.value;
    // Validate URL format
    console.log("input", url);
    if (!url) {
      setInputError('')
      setFetchUrlFailed1('')
      setButtonDisabled(false);
      setcloseDisabled(false);
    }
    if (!urlRegex.test(url)) {
      // Show error if URL format is invalid
      setInputError('Please provide a valid URL. You likely need to add “https://” at the start of your URL.')
      setFetchUrlFailed1('')

      return;
    } else {
      setInputError('')
      setFetchUrlFailed1('')

    }
    // // Extract domain name from URL
    // const domainRegex = /^https?:\/\/(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*)(?::\d+)?(?:\/\S*)?$/;
    // const match = domainRegex.exec(url);
    // if (match) {
    //   const domainName = match[1];

    //   // Check if domain name matches previous URLs
    //   for (let i = 0; i < newUrls.length; i++) {
    //     if (i !== index) {
    //       const match = domainRegex.exec(newUrls[i]);
    //       if (match && match[1] !== domainName) {
    //         // Show error if domain names don't match
    //         setInputError('Domain names do not match.')
    //         setFetchUrlFailed1('')

    //         // return;
    //       } else {
    //         setInputError('')
    //         setFetchUrlFailed1('')


    //       }

    //     }
    //   }
    // }

    // Get current cursor position
    // Update URLs array

    setUrls(url);
    setwebUrl(url);
    // Restore cursor position

  };



  const handleAddUrl = () => {
    const newUrls = webUrl
    let hasEmptyUrl = false;

    // Check if any of the current URLs are empty
    for (let i = 0; i < newUrls.length; i++) {
      if (!newUrls[i]) {
        hasEmptyUrl = true;
        break;
      }
    }

    if (hasEmptyUrl) {

      setInputError('Please enter a url before adding another one.')

    } else {
      newUrls.push('');
      setUrls(newUrls);
    }
  }

  useEffect(() => {
    setinputModalBody(sendmodalBodyInput())
    // setAttempts(attempts)
  }, [webUrl, buttonDisabled, inputError, valids, fetchUrlMessage, attempts, createMediumLengthMessage, fetchUrlFailed1]);

  const goback11 = () => {
    inputUrlForm.current.reset();
    setUrls("");
    setInputShowModal(false);
    setResponseUrlModal(false)
    setShowModal(true);
    setHasSubmitted(false)
    setInputError('');
    setFetchUrlFailed(null);
    setfetchUrlMessage(null);
    setfetchedUrlSuccess(null);
    setFetchUrlFailed1(null);
  };

  const goback1 = () => {
    setResponseUrlModal(true);
    setQuestionShowModal(false);

  };
  const goback = () => {
    setInputShowModal(true);
    setResponseUrlModal(false);

    setFetchUrlFailed(false);
    setButtonDisabled(false);
    setcloseDisabled(false);
    setfetchUrlMessage(null);
    setFetchUrlFailed1(null);
    setfetchedUrlSuccess(false);
    setFetchUrlFailed1(null);

  };



  // const [emailErrors, setEmailErrors] = useState([]);

  function handleAnswerChange(index, event) {
    event.preventDefault()

    const newAnswers = answers;
    newAnswers[index] = event.target.value;
    setAnswers(newAnswers);
  }


  function handleSubmits(event) {
    event.preventDefault();
    // your code to handle form submission...


    localStorage.setItem('answers', JSON.stringify(answers));
    setQuestionShowModal(false);
    setAiLastModal(true);
    setAiLastModalBody(sendmodalBodyai())
    setAiLastModalHeader(headerfunction())

    if (questions && questions.data) {
      const results = questions.data.map((q, index) => ({ q, a: answers[index] || '' }));
      dispatch(addFaqAnswerFromScrapped(results));
    }

  }

  useEffect(() => {
    setQuestionShowModalBody(sendmodalBodyQuestions(questions));
  }, [questions]);

  const storedAnswers = JSON.parse(localStorage.getItem('answers'));
  const sendmodalBodyQuestions = (data) => {

    return (
      <>
        {modalLoader && <div>Loading...</div>}
        <div className="tab-panes" id="steps4">
          <h2 className="text-black fw-bold text-center font-40 mb-5">
            We just had a few extra questions for you! <br /> If you don’t have
            an answer or it’s not important,<br /> feel free to leave any
            question blank!
          </h2>

          {data?.data?.map((question, index) => (
            <div className="my-3 form_textarea" key={index}>
              <label for="textarea">{question}</label>
              <textarea
                className="form-control"
                placeholder=""
                id={`textarea-${index}`}
                onChange={(event) => handleAnswerChange(index, event)}
              ></textarea>
            </div>
          ))}

          <div className="d-flex buttons_next justify-content-center mt-4">
            <button className="form_back_btn" onClick={() =>
              goback1()}>
              {" "}
              <img
                src={`${process.env.PUBLIC_URL}/images/back_btn.svg`}
                alt="Back button"
              />
            </button>

            <button className="main_btns" type="button" onClick={(e) =>
              handleSubmits(e)}
              style={domain ? {
                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                color: state.app.contextData?.buttonTextColor
              } : null}
            >
              Continue
            </button>
          </div>
        </div>
      </>
    );
  };

  const submitModal = () => {
    inputUrlForm.current.reset();

    setAiLastModal(false)
    setAiLastModalHeader(headerfunction())
    handleResetId();
    resetState();
    setShowOverLay(true);
    setShowOverLayBody(sendOverlay())
    setShowOverLayHeader(headerfunctions())
    handleLastBtnClick();
    disableScroll();
    setUrls('');
    // inputUrlForm.current.reset();


  }
  const goBackquestion = () => {
    setAiLastModal(false)
    setQuestionShowModal(true);
  }


  useEffect(() => {
    setAiLastModalBody(sendmodalBodyai());

  }, [state.app.contextData?.conversation_goal]);


  console.log(fetchUrlFailed1, 'fetchUrlFailed1')







  const resetInputValue = (index) => {
    // const input = inputRef.current[index];
    // if (input) {
    // 	input.defaultValue = '';
    // }
  };





  // useEffect(() => {
  //   if (index === undefined) return; // add a null check for index
  //   const interval = setInterval(() => {
  //     const chars = valids.split('');

  //     let timeout = 0;
  //     chars.forEach((char, index) => {
  //       timeout += 50;
  //       setTimeout(() => {
  //         const el = document.querySelector(`#char-${index}`);
  //         if (el) {
  //           el.classList.add('appear');
  //         }
  //       }, timeout);
  //     });
  //   }, 30);

  //   return () => clearInterval(interval);
  // }, [valids, index]);

  // useEffect(() => {
  //   if (index === undefined) return; // add a null check for index
  //   const interval = setInterval(() => {
  //     const chars = validity.split('');

  //     let timeout = 0;
  //     chars.forEach((char, index) => {
  //       timeout += 50;
  //       setTimeout(() => {
  //         const el = document.querySelector(`#char-${index}`);
  //         if (el) {
  //           el.classList.add('appear');
  //         }
  //       }, timeout);
  //     });
  //   }, 30);

  //   return () => clearInterval(interval);
  // }, [validity, index]);

  // const handleKeyPress = (e) => {
  //   if (e.key === 'Enter') {
  //     e.preventDefault();
  //     e.target.form.submit();
  //   }
  // };
  // const handleKeyDown = (event) => {
  //   if (event.key === 'Enter') {
  //     event.preventDefault();
  //     handleSubmit();
  //   }
  //   console.log('enter')
  // };
  // const handleKeyDown = (event) => {
  //   if (event.key === 'Enter') {
  //     event.preventDefault();
  //     inputUrlForm.current.dispatchEvent(new Event('submit', { cancelable: true }));
  //     handleSubmit();
  //     console.log('handle')
  //   }

  // };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setInputError('');
      setInputError1('')
      event.preventDefault();
      handleSubmit();
      // inputUrlForm.current.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  };
  const sendmodalBodyInput = () => {

    return (
      <>

        <div className="tab-panes" id="steps2">
          <h2 className="text-black fw-bold text-center font-40">Thank you for sharing your URL! We’re currently analyzing<br />  your website and writing an  overview on your <br /> company. This process   takes <br /> about a minute<img src={`${process.env.PUBLIC_URL}/images/smile.svg`} class="d-inline-block hand_icon" alt="hand_icon" />.</h2>


          <div class="step2-form" >
            <form ref={inputUrlForm}>
                  <div className='form-group'>
                    <input
                      type="text"
                  name="wev_url"
                      className="form-control"
                  defaultValue={webUrl.trim()}
                  onChange={(event) => handleUrlChange(event)}
                      style={{ marginBottom: 0 }}
                      onKeyDown={handleKeyDown}
                      // readonly={buttonDisabled}
                      disabled={buttonDisabled}


                    />
                    {fetchUrlMessage === index &&
                      <div style={{ display: 'flex' }}>
                    <p className='text-info text-left' style={{ marginBottom: 0 }}>Gathering information from the URL  provided</p>
                        <div class="spinner-grow text-info spinner-grow-sm" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-info spinner-grow-sm" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    }
                    {fetchUrlFailed === index &&
                      <div style={{ display: 'flex' }}>
                        <p className='text-success text-left' style={{ marginBottom: 0 }}>Gathering information from above url has been failed</p>
                      </div>
                    }
                    {
                      fetchUrlFailed1 === index &&
                      <div style={{ display: 'flex' }}>
                        <p className='text-danger text-left' style={{ marginBottom: 0 }}> Please provide url for above field</p>
                      </div>
                    }
                {/* {fetchedUrlSuccess && fetchedUrlSuccess.includes(index) &&
                  <div style={{ display: 'flex' }}>
                    <p className='text-success text-left' style={{ marginBottom: 0 }}>Gathering information from the URL(s) has been successfully completed</p>
                  </div>
                } */}
                  </div>


              {createMediumLengthMessage &&
                <div style={{ display: 'flex' }}>
                  <p className='text-info text-left'>{createMediumLengthMessage}</p>
                  <div class="spinner-grow text-info spinner-grow-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div class="spinner-grow text-info spinner-grow-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              }
              {createMediumLengthError &&
                <div style={{ display: 'flex' }}>
                  <p className='text-danger text-left'>{createMediumLengthError}</p>
                </div>
              }

              {inputError.length > 0 && <div style={{ color: 'red', marginBottom: '6px' }}>{inputError}</div>}
              {/* {valids && <div style={{ color: 'green', marginBottom: '6px' }}>{valids}</div>} */}
              {valids && (
                <div className="">
                  {valids.split('').map((char, index) => (
                    <span style={{ color: 'green' }} key={index} id={`char-${index}`} className="char">
                      {char}
                    </span>
                  ))}
                </div>
              )}
              {validity && (
                <div className="">
                  {validity.split('').map((char, index) => (
                    <span style={{ color: 'green' }} key={index} id={`char-${index}`} className="char">
                      {char}
                    </span>
                  ))}
                </div>
              )}


              {/* <p >Content rich pages like your homepage, about us pages, or<br /> pricing pages work best!</p> */}
            </form>
          </div>

          <div className="d-flex buttons_next justify-content-center mt-4">

            {/* <button disabled={buttonDisabled} className="form_back_btn" onClick={() => goback11()}

            > <img src={`${process.env.PUBLIC_URL}/images/back_btn.svg`} /> </button> */}

            <>
              <button
                className="main_btns"
                style={domain ? {
                  backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                  color: state.app.contextData?.buttonTextColor
                } : null}
                onClick={handleSubmit}
                disabled={buttonDisabled || inputError}
              >
                Submit

              </button>

            </>

          </div>
        </div>


      </>
    )
  }





  const showUrldata = (data) => {
    return (
      <>
        <div className="tab-panes text-center" id="steps3">
          <h2 className="text-black fw-bold text-center font-40">Here’s what we came up with! If you want to make <br /> any edits, feel free to do so! Don’t worry, <br /> you can always edit it later.</h2>

          <textarea
            className='scroll_pehras'
            value={data?.data || data}
            readOnly
          />
          {/* {createMediumLengthMessage &&
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <p className='text-info text-left'>Please wait until we gathering information</p>
              <div class="spinner-grow text-info spinner-grow-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="spinner-grow text-info spinner-grow-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          } */}
          {dataError && <div style={{ color: 'red' }}>{dataError}</div>}


          <div className="d-flex buttons_next justify-content-center mt-4">
            <button className="form_back_btn" disabled={createMediumLengthMessage} onClick={() => goback()}>
              <img src={`${process.env.PUBLIC_URL}/images/back_btn.svg`} />
            </button>


            <button
              style={domain ? {
                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                color: state.app.contextData?.buttonTextColor
              } : null}
              className="main_btns" type="button" onClick={() =>
                handleOptionQustion(data)}
              disabled={createMediumLengthMessage}

            >
              Continue

            </button>


          </div>



        </div >
      </>
    )
  }



  useEffect(() => {
    getIPAddress();
    const domaina = !domainlist.includes(window.location.hostname) ? window.location.hostname : '';
    setDomain(domaina);
    dispatch(fetchContext({ id: (contextId.id && contextId.id.startsWith('zy') && !contextId.id.includes('_')) ? contextId.id : '', domain: domaina }));
  }, []);

  const getIPAddress = () => {
    axios.get('https://api64.ipify.org/?format=json').then((res) => {
      setclientIpAddress(res.data?.ip)
    }).catch((err) => {
      console.log(err);
    });
  }
  console.log(clientIpAddress, 'clientIpAddress')

  const [companyNameError, setCompanyNameError] = useState('');
  const [emailErrors, setEmailErrors] = useState('');
  const [emailError1, setEmailError1] = useState('');
  const [emailManagerError, setemailManagerError] = useState('');
  const [readAndAgreeErrors, setReadAndAgreeErrors] = useState('');
  const [companyNameValue, setCompanyNameValue] = useState(state.demoForm.companyName || '');



  const onAddQuestionFaq = () => {

  }

  const openDemoForm = () => {
    disableScroll();
    setshowAskForModal(true);
    setmodalBody(setupAccountForm());

  }

  const closeModals = () => {
    enableScroll();
    setshowAskForModal(false);
    setInputError('');
    setSelectedOptionValues(null)
    companyNameRef.current.value = null;
    additionalNotesRef.current.value = null;
    websiteManagerEmailRef.current.value = null;
    websiteManagerNameRef.current.value = null;
    phoneNumberToSendLeadRef.current.value = null;
    emailLeadRef.current.value = null;
    companyUrlRef.current.value = null;
    companyContactNumberRef.current.value = null;
    setCompanyNameError('');
    setEmailError('')
    setEmailError1('')
    setNameError('')


  }



  const removeSendEmailLead = (e) => {
    dispatch(demoFormAction.deleteEmailLead(e));
  }

  const checkReadAndAgree = () => {
    dispatch(demoFormAction.checkAgree());

    if (state.demoForm.readAndAgree) {
      setReadAndAgreeErrors('Please check this box if you want to proceed.')
    } else {
      setReadAndAgreeErrors('')
    }
  }


  const handleFormInput = (e, inputRef) => {
    const value = inputRef.current.value || e.target.value;
    const name = inputRef.current.name;

    if (name === 'companyName') {
      if (value.trim() === '') {
        setCompanyNameError('Company name is required.');
      } else if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
        setCompanyNameError('Company name should only contain letters, numbers, and spaces.');
      } else {
        setCompanyNameError('');
      }
    }
    if (name === 'emailLead') {
      if (value === '') {
        setEmailError('');
      } else if (!/^\S+@\S+\.\S+$/.test(value)) {
        setEmailError('Please provide valid email address.');
      } else {
        setEmailError('');
      }
    }
    if (name === 'websiteManagerEmail') {
      if (value === '') {
        setEmailError1('');
      } else if (!/^\S+@\S+\.\S+$/.test(value)) {
        setEmailError1('Please provide valid email address.');
      } else {
        setEmailError1('');
      }
    }
    if (name === 'websiteManagerName') {
      if (value === '') {
        setNameError('');
      } else if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
        setNameError('Manager name should only contain letters, numbers, and spaces.');
      } else {
        setNameError('');
      }
    }
    const payl = [name, value];
    dispatch(demoFormAction.onAddFormInput(payl));
  };

  const keylist = [13, 188];
  const emailLeadKeyCheck = (e, emailRef) => {
    if (keylist.includes(e.keyCode)) {
      if (state.demoForm.emailToSendLeads.includes(emailRef.current.value)) {
        return;
      }

      dispatch(demoFormAction.addEmailLeadList(emailRef.current.value));
    }
  }
  const emailFocusOut = (e, emailRef) => {
    if (!emailRef.current.value) {
      return;
    }
    if (state.demoForm.emailToSendLeads.includes(emailRef.current.value)) {
      return;
    }

    dispatch(demoFormAction.addEmailLeadList(emailRef.current.value));
  }
  const [playground, setPlayground] = useState('')
  const submitDemoForm = async () => {
    // Check if company name is provided
    let isValid = true;
    // if (!state.demoForm.companyName) {
    //   setCompanyNameError('Company name is required.')
    //   isValid = false;
    // } else if (!/^[a-zA-Z0-9\s]+$/.test(!state.demoForm.companyName)) {
    //   setCompanyNameError('Company name should only contain letters, numbers, and spaces.');
    // } else {
    //   setCompanyNameError('')
    // }
    if (!state.demoForm.companyName) {
      setCompanyNameError('Company name is required.');
      isValid = false;
    } else if (!/^[a-zA-Z0-9\s]+$/.test(state.demoForm.companyName)) {
      setCompanyNameError('Company name should only contain letters, numbers, and spaces.');
      isValid = false;

    } else {
      setCompanyNameError('');
    }
    if (!state.demoForm.readAndAgree) {
      setReadAndAgreeErrors('Please check this box if you want to proceed.')
      isValid = false;
    } else {
      setReadAndAgreeErrors('')
    }
    if (emailError !== '') {
      isValid = false;
    } else {
      setEmailError('')
    }



    if (emailError1 !== '') {
      isValid = false;
    } else {
      setEmailError1('')
      // isValid = true;


    }
    if (nameError !== '') {
      isValid = false;
    } else {
      setNameError('')
      // isValid = true;
    }

    if (isValid) {

      // if (!state.app.playgroundId) {
      //   onSavePlayground('new')
      // }

      const data = JSON.parse(JSON.stringify(state.demoForm));
      data['emailToSendLeads'] = JSON.stringify(data['emailToSendLeads']);
      data.ipAddress = clientIpAddress;
      data.playground = state.app.playgroundUniqueId;
      delete data['submitDisable'];
      if (!state.app.playgroundId) {
        try {
          const playgroundResult = await onSavePlayground('new');
          const playgroundId = playgroundResult.playground; // Access the generated playgroundId from playgroundResult
          data.playground = playgroundId; // Use the generated playgroundId

        } catch (error) {
          // Handle onSavePlayground error if necessary
        }
      }
      // Submit the form if all required fields are valid


      setTimeout(async () => {
        await dispatch(postDemoForm(data));


      }, 1000);
      enableScroll();
      companyNameRef.current.value = null;
      additionalNotesRef.current.value = null;
      websiteManagerEmailRef.current.value = null;
      websiteManagerNameRef.current.value = null;
      phoneNumberToSendLeadRef.current.value = null;
      emailLeadRef.current.value = null;
      companyUrlRef.current.value = null;
      companyContactNumberRef.current.value = null;
      // await dispatch(postDemoForm(data));

      setshowAskForModal(false);

      setRegisterFormModal(true);
      setRegisterFormModalBody(setUpRegisterForm());


    }
  }

  const LoadingTost = () => {
    return (
      <div className="d-flex align-items-center text-success">
        <strong>Loading...</strong>
        <div className="spinner-border ml-auto" role="status" aria-hidden="true"></div>
      </div>
    )
  }

  useEffect(() => {

    setmodalBody(setupAccountForm());
  }, [state.demoForm, state.aiForm, companyNameValue, companyNameError, readAndAgreeErrors, emailError, selectedOptionValues, nameError]);
  // useEffect(() => {
  //   if (!state.demoForm.companyName) {
  //     setmodalBody(setupAccountForm());
  //   }
  // }, [state.demoForm]);

  const setupAccountForm = () => {
    // const defaultValue={...state.demoForm.companyName }
    return (
      <div className='row px-2 py-4'>
        <div className='col-md-12 setupaccounts-title'>
          <h3 className='box-title'>Setup my account</h3>
          {/* <p>We will use the customization provided above to create your account</p> */}
        </div>
        <div className='col-md-12 px-5 setupaccounts-body'>
          <div className='form-group'>



            <input
              type="text"
              name='companyName'
              className='form-control'
              placeholder='Company Name'
              ref={companyNameRef}
              // value={state.demoForm.companyName}

              onChange={(e) => handleFormInput(e, companyNameRef)}
            />




            {companyNameError && <div style={{ color: 'red' }}>{companyNameError}</div>}

          </div>
          <div className='form-group'>

            <input
              type="text"
              name='companyContactNumber'
              className='form-control'
              placeholder='Company Contact Number'
              // pattern="\d{10}"
              value={state.demoForm.companyContactNumber}
              ref={companyContactNumberRef}
              onChange={(e) => handleFormInput(e, companyContactNumberRef)}
            />

          </div>
          <div className='form-group'>
            <input
              type="text"
              name='companyUrl'
              className='form-control'
              placeholder='Company URL'
              // value={state.demoForm.companyUrl}
              ref={companyUrlRef}
              onChange={(e) => handleFormInput(e, companyUrlRef)}
            />

          </div>
          <div className='form-group'>
            <div className='bootstrap-tagsinput'>
              {state.demoForm.emailToSendLeads && state.demoForm.emailToSendLeads.map((item, i) => (
                <span className="tag label label-info">{item}<span data-role="remove" onClick={() => removeSendEmailLead(i)}>
                </span></span>
              ))}
              <input
                type="text"
                name='emailLead'
                className='form-control'
                placeholder='Emails to send leads to'
                value={state.demoForm.emailLead}
                ref={emailLeadRef}
                onChange={(e) => handleFormInput(e, emailLeadRef)}
                onKeyDown={(e) => emailLeadKeyCheck(e, emailLeadRef)}
                onBlur={(e) => emailFocusOut(e, emailLeadRef)}
              />

            </div>
            {emailError && <div style={{ color: 'red' }}>{emailError}</div>}
            <small style={{ color: '#0603B8' }}>Use commas (,) or Press Enter key as separators for multiple email recipients</small>
          </div>
          <div className='form-group'>
            {/* {!state.demoForm.phoneNumberToSendLead ? */}
            <input
              type="text"
              // maxLength={10}

              name='phoneNumberToSendLead'
              className='form-control'
              placeholder='Phone numbers to send leads to (optional)'
              value={state.demoForm.phoneNumberToSendLead}
              ref={phoneNumberToSendLeadRef}
              onChange={(e) => handleFormInput(e, phoneNumberToSendLeadRef)}
            />

          </div>
          <div className='form-group'>
            <input
              type="text"
              name='websiteManagerName'
              className='form-control'
              placeholder='Website Manager Name'
              // value={state.demoForm.websiteManagerName}
              ref={websiteManagerNameRef}
              onChange={(e) => handleFormInput(e, websiteManagerNameRef)}
            />
            {nameError && <div style={{ color: 'red' }}>{nameError}</div>}

          </div>

          <div className='form-group'>

            <input
              type="text"
              name='websiteManagerEmail'
              className='form-control'
              placeholder='Website Manager Email'
              // value={state.demoForm.websiteManagerEmail}
              ref={websiteManagerEmailRef}
              onChange={(e) => handleFormInput(e, websiteManagerEmailRef)}
            />
            {emailError1 && <div style={{ color: 'red' }}>{emailError1}</div>}



          </div>
          <div className='form-group'>
            <input
              type="text"
              name='additionalNotes'
              className='form-control'
              placeholder='Additional Notes (optional)'
              // defaultValue={state.demoForm.additionalNotes}
              ref={additionalNotesRef}
              onChange={(e) => handleFormInput(e, additionalNotesRef)}
            />
          </div>
          <div className='form-group'>

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip" style={{ boder: 'none' }} >To assist with the onboarding process, your website manager will be notified with installation instructions. You will also be CCd on this email.</Tooltip>}
            >
              <span style={{ color: '#0603B8', cursor: 'pointer' }}>
                <label style={{ color: '#0603B8', cursor: 'pointer' }}><b>Why do you need this info ?</b></label>
              </span>
            </OverlayTrigger>

          </div>


          <div className="mb-2 form-check" style={{ marginTop: -12 }}>
            <input
              name='readAndAgree'
              type="checkbox"
              className="form-check-input"
              id="checkmeout"
              checked={state.demoForm.readAndAgree}
              onChange={checkReadAndAgree}
            />
            <label className="form-check-label" htmlFor="checkmeout">
              I have read and agree with the <a href="https://www.zyratalk.com/terms" target="_blank" style={{ textDecoration: 'none' }}>
                Terms of Use</a>, <a href="https://www.zyratalk.com/platformagreement" target="_blank" style={{ textDecoration: 'none' }}>
                Platform Agreement</a> and <a href="https://www.zyratalk.com/privacy" target="_blank" style={{ textDecoration: 'none' }}>
                Privacy Policy</a> {domain ? <>of the underlying technology</> : ''}</label>
            <p className="text-danger small" id="checkmeoutError"></p>
            {readAndAgreeErrors && <div className="error" style={{ color: 'red' }}>{readAndAgreeErrors}</div>}

          </div>

        </div>
        <div className='col-md-12 d-flex setupaccount-footer'>
          <button disabled={state.demoForm.submitDisable} className=" cancel_btn" onClick={closeModals}>
            <span>Cancel</span>
          </button>
          {/* <button

            // disabled={state.demoForm.submitDisable}
            onClick={submitDemoForm}
            className='main_btns linear-gradient'>
            {state.demoForm.submitDisable ?
              <div className="spinner-border ml-auto" role="status" aria-hidden="true"
                style={domain && {
                  backgroundImage: 'linear-gradient(45deg,' + state.app.contextData?.primaryColor + ',' + state.app.contextData?.secondaryColor + ')',
                  color: state.app.contextData?.buttonTextColor,
                }}
              ></div> : 'Continue'
            }
          </button> */}
          <button
            // disabled={state.demoForm.submitDisable}
            onClick={submitDemoForm}
            className={`main_btns linear-gradient ${domain ? 'white-label' : ''}`}

            style={domain ? {
              backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
              color: state.app.contextData?.buttonTextColor
            } : null}
          >
            {state.demoForm.submitDisable ?
              <div
                className="spinner-border ml-auto"
                role="status"
                aria-hidden="true"
              ></div> : 'Continue'
            }
          </button>
        </div>
      </div>
    );
  }



  const backModals = () => {
    inputSetupForm.current.reset();
    setshowAskForModal(true);
    setRegisterFormModal(false);
  }

  const [email, setEmail] = useState('');
  const [passwords, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState('');
  const [readAndAgreeLogin, setReadAndAgreeLogin] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const PasswordField = useRef('')
  const [blurred, setBlurred] = useState(false);
  const [readAndAgreeError, setReadAndAgreeError] = useState('');

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setEmailError('')
    setAllError('')
  }
  const handlePasswordBlur = () => {
    setBlurred(true);

  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordError('')
  }

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    setConfirmPasswordError('')
  }

  // function handleCheckboxChange() {
  //   setReadAndAgreeLogin(true);
  //   setReadAndAgreeError('')
  // }
  function handleCheckboxChange(event) {
    const checked = event.target.checked;
    setReadAndAgreeLogin(checked);
    if (!checked) {
      setReadAndAgreeLogin(false)
    }
    setReadAndAgreeError('');
  }
  const [allError, setAllError] = useState('');

  useEffect(() => {
    setRegisterFormModalBody(setUpRegisterForm());

  }, [allError, email, passwords, confirmPassword, readAndAgreeLogin, emailError, passwordError, confirmPasswordError, readAndAgreeError]);
  const submitRegisterForm = async (e) => {



    let isValid = true;
    e.preventDefault()

    if (!email) {
      setEmailError('Please enter your email.');
      isValid = false;
    } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setEmailError('Please enter a valid email.');
      isValid = false;
    }

    if (!passwords) {
      setPasswordError('Please enter your password.');
      isValid = false;
    } else if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.*\s).{8,}/.test(passwords)) {
      setPasswordError('Password needs to be at least 8 characters, include an uppercase and lowercase letter, a number, and a symbol.');
      isValid = false;
    }

    if (!confirmPassword) {
      setConfirmPasswordError('Please enter your confirm password.');
      isValid = false;
    } else if (passwords !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match.');
      isValid = false;
    }

    if (!readAndAgreeLogin) {
      setReadAndAgreeError('Please check this box if you want to proceed.');
      isValid = false;
    }

    // perform registration logic

    // Create a new FormData object
    const formData = new FormData();

    // Append the values of the additional fields to the form data
    formData.append('companyName', state?.aiForm?.companyName);
    formData.append('companyContactNumber', state?.aiForm?.companyContactNumber);
    formData.append('companyUrl', state?.aiForm?.companyUrl);


    formData.append('emailToSendLeads', [state?.aiForm?.emailToSendLeads]);
    formData.append('phoneNumberToSendLead', state?.aiForm?.phoneNumberToSendLead);
    formData.append('websiteManagerName', state?.aiForm?.websiteManagerName);
    formData.append('websiteManagerEmail', state?.aiForm?.websiteManagerEmail);
    formData.append('additionalNotes', state?.aiForm?.additionalNotes);
    formData.append('readAndAgree', state?.aiForm?.readAndAgree);
    formData.append('ipAddress', clientIpAddress);
    formData.append('HTTP_HOST', '');
    formData.append('companyLogo', state?.app?.contextData?.companyLogo);
    formData.append('mobileNo', state?.aiForm?.emailLead);
    formData.append('primary_color', state?.app?.contextData?.primaryColor);
    formData.append('secondary_color', state?.app?.contextData?.secondaryColor);
    formData.append('button_color', state?.app?.contextData?.buttonColor);
    formData.append('button_text_color', state?.app?.contextData?.buttonTextColor);
    formData.append('cahtversion', '');
    formData.append('selected_theme', state?.app?.contextData?.selectedTheme);


    // Append the email, password, and confirmPassword values to the form data
    formData.append('loginEmail', email);
    formData.append('loginPassword', passwords);
    formData.append('loginConfirmPassword', confirmPassword);
    formData.append('readAndAgreeLogin', readAndAgreeLogin);
    if (isValid) {

      // Make the API call to save the login
      try {
        const response = await fetch(`${config.baseurl}/newengage/public/api/saveLogin`, {
          method: 'POST',
          body: formData
        });
        const data = await response.json();
        if (data?.status === false) {

          setAllError(data?.msg)

          return;
        } else {
          setAllError('')

          setRegisterFormModal(false);
          setshowAskForModal(false)

          toast.success(data?.msg, {
            position: "top-right",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          window.location.reload()

        }

      } catch (error) {
        console.error(error);
      }
    }
  }








  const sendmodalBodyai = (data) => {




    return (
      <>
        <div class="tab-panes" id="steps5">
          <h2 class="text-black fw-bold text-center font-40">What is the overall goal of your conversation ?</h2>
          <div class="row mt-3">
            <div class="col-lg-12">


              <textarea

                className='scroll_pehra'
                onChange={saveConversation}
                defaultValue={state?.app?.contextData?.conversation_goal.replace(/<br\/>/g, '\n')}
                ref={conversationGoalRef}
                style={{ whiteSpace: 'pre-wrap' }}
              >
              </textarea>


            </div>
          </div>

          <div class="d-flex buttons_next justify-content-center mt-4">
            <button class="form_back_btn" onClick={goBackquestion}>  <img
              src={`${process.env.PUBLIC_URL}/images/back_btn.svg`}
              alt="Back button"
            /> </button>
            {/* <div id="locations" ref={locationsRef} /> */}


            <button
              id="last-btn"
              class="main_btns" type="submit" onClick={submitModal}
              // data-bs-toggle="modal" data-bs-target="#exampleModalNew":''}
              // data-bs-toggle="modal" data-bs-target="#exampleModalNew"
              style={domain ? {
                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                color: state.app.contextData?.buttonTextColor
              } : null}
            >Continue</button>
          </div>


        </div >
      </>
    );
  };





  const setUpRegisterForm = () => {


    const handleKeyDown = (e) => {
      if (e.keyCode === 32) {
        e.preventDefault();
      }
    };

    return (
      <>
        <div id="part2" class="form-group">
          <form ref={inputSetupForm}>
          <div class="panel panel-primary">
            <div class="col-md-12 setupaccount-title">
              <h3 class="box-title">Setup my account</h3>


            </div>
            <div class="form-group" autoComplete='off'>

              <input type="text" name="email" value={email} class="form-control" autoComplete='off' placeholder="Login email" onChange={handleEmailChange} />
              {emailError && <div style={{ color: 'red', textAlign: 'left' }}>{emailError}</div>}
              {allError
                && <div style={{ color: 'red', textAlign: 'left' }}>{allError
                }</div>}
            </div>

            <div class="form-group" autoComplete='new-password'>
              <input type="password" value={passwords} class="form-control"
                name="email"
                onBlur={handlePasswordBlur}

                autoComplete='new-password' onKeyDown={handleKeyDown} placeholder="Password" onChange={handlePasswordChange} />
              {passwordError && <div style={{ color: 'red', textAlign: 'left' }} >{passwordError}</div>}
            </div>

            <div class="form-group" autoComplete='off'>
              <input type="password" name="confirmPassword" value={confirmPassword} autoComplete='off' class="form-control" onKeyDown={handleKeyDown} placeholder="Confirm Password" onChange={handleConfirmPasswordChange} />
              {confirmPasswordError && <div style={{ color: 'red', textAlign: 'left' }}>{confirmPasswordError}</div>}

            </div>
            <div class="form-group">
              <div class="mb-3 form-check">

                <input
                  name="readAndAgreeLogin"
                  type="checkbox"
                  className="form-check-input"
                  id="checkmeout"
                  checked={readAndAgreeLogin}
                  onChange={handleCheckboxChange}
                />

                <label class="form-check-label" for="checkmeout">I have read and agree with the
                  <a href="https://www.zyratalk.com/terms" target="_blank" style={{ textDecoration: 'none' }}>&nbsp;Terms of Use</a>, &nbsp;
                    
                    and <a href="https://www.zyratalk.com/privacy-policy" target="_blank" style={{ textDecoration: 'none' }}>Privacy Policy</a>&nbsp;of the underlying technology</label>

                {readAndAgreeError && <div style={{ color: 'red', textAlign: 'left' }}>{readAndAgreeError}</div>}

              </div>
            </div>

            <div class="btn-group btn-group-lg setupaccount-footer" role="group" aria-label="...">
              <label for='step2' id="back-step2" class="back">
                  <div class=" cancel_btn" role="button" onClick={backModals}> Back</div>
              </label>
              <label class="continue">
                <button type="submit" class="main_btns"
                  onClick={submitRegisterForm}

                  style={domain ? {
                    backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                    color: state.app.contextData?.buttonTextColor
                  } : null}

                >Submit</button>
              </label>
            </div>

            {/* </form> */}
          </div>
          </form>
        </div>
      </>
    );
  }

  const borderImageSource = "linear-gradient(to left, #0c0c6a, #171678)";
  const styles = {
    borderImageSource: borderImageSource
  };
  const [optionData, setOptionData] = useState('')






  const [templateData, setTemplateData] = useState(null);
  const [ids, setDataId] = useState('');


  const handleOptionChange = (event) => {
    const selectedOptionValue = event.target.value;
    let id = contextId; // default id
    const domaina = !domainlist.includes(window.location.hostname) ? window.location.hostname : '';

    if (selectedOptionValue === 'zy642dc7c895b6b') {
      id = 'zy642dc7c895b6b';
    } else if (selectedOptionValue === 'zy6424b8f764141') {
      id = 'zy6424b8f764141';
    } else if (selectedOptionValue === 'zy64370a6e9414e') {
      id = 'zy64370a6e9414e';
    }
    setSelectedOptionValues(id)
    setShowModal(false);
    setDataId(id);
    dispacth(onChangeSelectTemplate(id));
    dispatch(fetchContext({ id, domain: domaina }));
  }
  const handleResetId = () => {
    setDataId('');
  };
  const resetState = () => {
    setSelectedOptionValues('0');
    setDataId('');
  };

  let hColorMultiArr = [];
  let hColorMulti = '';
  if (state?.app.contextData?.buttonHeaderColor?.length > 1) {
    state?.app.contextData?.buttonHeaderColor.map((x, y) => {
      hColorMultiArr.push(x);
    });
    hColorMulti = hColorMultiArr.join();
  }


  let bColorMultiArr = [];
  let bColorMulti = '';
  if (state.app.contextData?.buttonColor.length > 1) {
    state.app.contextData?.buttonColor.map((x, y) => {
      bColorMultiArr.push(x);
    });
    bColorMulti = bColorMultiArr.join();

  }
  const handleurlinput = (e) => {
    setwebUrl(e.target.value)
    setUrls(e.target.value);
    setwebUrlError("");
  }

  const handleWorkEmailChange = (e) => {
    setWorkEmail(e.target.value);
  };

  const handleRequestDemo = (e) => {
    e.preventDefault();
  
    if (workEmail.trim() === '') {
      toast.error('Please enter your work email.');
      return;
    }
  
    if (!/^\S+@\S+\.\S+$/.test(workEmail)) {
      toast.error('Please enter a valid email address.');
      return;
    }
  
    // Ensure `grecaptcha` is loaded in the global scope
    if (!window.grecaptcha) {
      console.error("Google reCAPTCHA not loaded. Make sure the script is included.");
      return;
    }
  
    setRequestDemoloading(true);
    setRequestDemoButtonDisabled(true);
  
    window.grecaptcha.ready(async function () {
      try {
        // Execute reCAPTCHA
        const token = await window.grecaptcha.execute("6LfhLKQkAAAAADv4QLes3emiEmZx7ReBBiT6YbBN", {
          action: "submit",
        });
  
        if (token) {
          // Send form data and token to the backend using Axios
          const response = await axios.post(`${config.baseurl}/api/partneronboarding/demorequest`, {
            email: workEmail,
            token, // Include the reCAPTCHA token
            from: 'playground'
          });
  
          setRequestDemoloading(false);
          setRequestDemoButtonDisabled(false);
  
          const { data } = response;
  
          if (data.status) {
            toast.success(data.message);
            setWorkEmail("");
          }
  
          console.log("Request demo response:", data);
        }
      } catch (error) {
        setRequestDemoloading(false);
        setRequestDemoButtonDisabled(false);
  
        // Handle error
        if (error.response) {
          // Backend returned an error
          toast.error(error.response.data.message || "Something went wrong. Please try again.");
          console.error("Request demo error:", error.response.data);
        } else {
          // Network error or other issues
          toast.error("Unable to send the request. Please try again later.");
          console.error("Request demo error:", error.message);
        }
      }
    });
  };

  return (
    <>
      {/* {domain &&
        <Helmet>
          <link rel="icon" href={`${config.baseurl}/assets/images/resellerLogo/${faviconUrl}`} />
        </Helmet>} */}
      {domain && (
        <Helmet>
          <link rel="icon" href={`${config.baseurl}/assets/images/resellerLogo/${faviconUrl}`} />
        </Helmet>
      )}
      {sitedomain && <Helmet>
        <link rel="icon" href={`${process.env.PUBLIC_URL}/zyrafavicon.png`} />
        </Helmet>}
      <ToastContainer />
      {state.app.contextData &&
        <Headerai isWhiteLable={domain ? true : false} domain={domain} />}

      <div className="main_theme color-Palate">
        <section className="banner_section">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">

                <div className="banner_content">
                  <h1>Training AI chat has never been this easy</h1>
                  <p className="py-3">All you have to do is enter your website and our AI will do the rest. <br /> Seriously, it's that easy.</p>
                  <div className={`${domain && 'white-lable'}`} id='ai-btn'>

                    <div className='divnextform'>
                      <input type='url' placeholder='Enter your website' className='form-control weburl1' value={webUrl} name="website_url" onChange={(e) => handleurlinput(e)} onKeyDown={handleKeyDown1} />
                      <button className='continueBtn main_btns integrate_btn text-decoration-none ' style={domain ? { backgroundImage: 'linear-gradient(45deg,' + state.app.contextData?.primaryColor + ',' + state.app.contextData?.secondaryColor + ')', color: state.app.contextData?.buttonTextColor } : { width: 'auto' }} onClick={(e) => ShowFirstPopup(e)}>Continue</button>
                    </div>
                    {webUrlError.length > 0 && <div style={{ color: 'red', marginBottom: '6px',width:'90%',marginTop:"5px" }}>{webUrlError}</div>}
                  </div>
                </div>
                {/* <li class="nav-item"> */}
                {
                  domain ?
                  <></> :
                  <a href={`${config.baseurl}/request-demo`} class="nav-link btn btn-primary dash mr-lg-0 me-lg-4 px-4 sign-up-btn text-white">Set up my account - We'll do it for you</a>
                }
                {/* </li> */}
                {/* <button class="main_btns my-account-btn" >Set Up My Account</button> */}
              </div>
   {(domain && 'white-lable' && window.location.hostname.includes("tdmi.chat-dashboard.com")) && <div className="col-lg-7 banner-videos">
              <video width="100%" height="435" controls controlsList="nodownload" >
                <source src={`${process.env.PUBLIC_URL}/videos/The-Dental-Marketing-Institute_Train-the-AI-Specific-to-Your-Company-23-May-2024.mp4`} type="video/mp4"/>
                </video>
                </div> }
                {(domain && 'white-lable' && window.location.hostname.includes("dexcomm.chat-dashboard.com")) && <div className="col-lg-7 banner-videos">
              <video width="100%" height="435" controls controlsList="nodownload" >
                <source src={`${process.env.PUBLIC_URL}/videos/Dexcomm-AI-Chat.mp4`} type="video/mp4"/>
                </video>
                </div> }
                {(domain && 'white-lable' && !WhiteLablevideoUrls.includes(window.location.hostname)) && <div className="col-lg-7 banner-videos">
                  <img src={`${process.env.PUBLIC_URL}/images/change-image.svg`} alt="" className="img-fluid" />
                  </div> }

                  {(!domain &&  window.location.hostname.includes("www.zyratalk.com")) && <div className="col-lg-7 banner-videos">
                  <iframe src="https://www.youtube.com/embed/mKapY-qSkYk" title="How to Train an AI Chatbot in 60 Seconds for your Website - ZyraTalk" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>}

             

            </div>
          </div>
        </section>

      </div>
      <div className={`main_theme ${domain && 'white-lable'}`}>
        <section className="get-started py-5">
          <div className="container">
            <div className='row'>
              <div className="col-lg-3 px-0 get-starteddiv">
                <h2 className='text-dark fs-4 fw-bold'>Get Started</h2>
                <p>Welcome to our playground! Use our context builder to let us know more information about our company or website.</p>
                <p>With the provided information, we'll build training material to plug into our AI model and allow for a simulated human conversation to take place.</p>
                <p>This conversation can be plugged in directly on to your website, and company phone line.</p>
              </div>

              <div className='col-lg-9 '>
                {
                  state.app.contextData &&

                  <ul className="nav nav-pills mb-4" id="pills-tab" role="tablist">

                    {domain && 'white-lable' ?
                      <>


                        <li className="nav-item" role="presentation">
                          <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" >Edit context</button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Edit logos/color</button>
                        </li>
                      </> : <>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link active" style={styles} id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Edit context</button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link" id="pills-profile-tab" style={styles} data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Edit logos/color</button>
                        </li>
                      </>
                    }
                  </ul>
                }
                <div className="tab-content border p-2 rounded-3" id="pills-tabContent">
                  {state.app.loading &&
                    <div className='d-flex justify-content-center'>
                      <div className="spinner-border text-success" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  }
                  {state.app.contextData &&
                    <>
                      <TopActionButtonai defaultData={state} results={results}
                        dataUrl={dataUrl}
                        dataUrls={editedData}
                        handleOptionClick={handleOptionClick}
                        templateData={templateData}
                        handleOptionChange={handleOptionChange}
                        selectedOptionValues={selectedOptionValues}
                      />
                      <div id="locations" ref={locationsRef}></div>

                      <EditContextai
                        handleOptionClick={handleOptionClick}
                        defaultData={state.app.contextData}
                        onAddQuestionFaq={onAddQuestionFaq}
                        dataUrls={editedData}
                        dataUrl={dataUrl}
                        answers={answers}
                        questions={questions}
                        results={results}
                        templateData={templateData}
                        isWhiteLable={domain ? true : false}
                        locationsRef={locationsRef}
                        dataSubmit={dataSubmit}


                      />
                      <EditLogo isWhiteLable={domain ? true : false} />



                    </>
                  }

                </div>
              </div>
            </div>
          </div>
        </section>
        {
          state.app.contextData &&
          <>
            <PersonalizedDemoai isWhiteLable={domain ? true : false} />
            <PreviewChatai isWhiteLable={domain ? true : false} />


            <section className="my-account-section py-5">
              <div className="container">
                <div className="text-center">
                  <p className="fw-bold text-center text-dark fs-1 mb-5">Impressed? Let’s get you started!</p>


                  {/* <button class="main_btns my-account-btn" onClick={openDemoForm} data-bs-toggle="modal" data-bs-target="#exampleModal"
                    style={domain ? {
                      backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                      color: state.app.contextData?.buttonTextColor
                    } : null}
                  >Setup My Account</button> */}
                </div>
                <div className='col-md-4' style={{marginLeft: 'auto', marginRight: 'auto'}}>
                {requestDemoloading &&
                    <div className='d-flex justify-content-center'>
                      <div className="spinner-border text-success" role="status">
                        <span className="sr-only">Loading...</span>
              </div>
                    </div>
                  }
                  <div className='divnextform' style={{width: '100%'}}>
                    <input type='url' placeholder='Your work email' className='form-control weburl1' value={workEmail} name="work_email" onChange={(e) => handleWorkEmailChange(e)}  />
                    <button disabled={requestDemoButtonDisabled} className='continueBtn main_btns integrate_btn1 text-decoration-none ' style={domain ? { backgroundImage: 'linear-gradient(45deg,' + state.app.contextData?.primaryColor + ',' + state.app.contextData?.secondaryColor + ')', color: state.app.contextData?.buttonTextColor } : { width: 'auto' }} onClick={(e) => handleRequestDemo(e)}>Request Demo</button>
                  </div>
                </div>
              </div>
            </section>
            {domain ?
              <></>
              :
              <Footer clientIpAddress={clientIpAddress} />

            }
            <ModalSignup
              show={showAskForModal}
              modalFooter={modalFooter}
              modalBody={modalBody}
              title={modaltitle}
              closeModal={closeModals}
              modalLoader={modalLoader}

            />
            {/* 
            <ModalSignup
              show={registerFormModal}
              modalBody={registerFormModalBody}

            /> */}
            <>
              <Modal
                show={showModal}
                modalBody={aimodalBody}
                modalHeader={aimodalHeader}
                closeModal={closeModal}
              />
              <OerlayModal
                show={showOverLay}
                modalBody={showOverLayBody}
                onClose={handleCloseModal}
                onLastBtnClick={handleLastBtnClick}
                showArrow={showArrow}
                modalHeader={showOverLayHeader}
              // closeModal={closeModal}
              />
              <Modal
                show={inputshowModal}
                modalBody={inputModalBody}
                modalHeader={inputModalHeader}
                closeModal={closeModal}
                modalLoader={modalLoader}
                closeDisabled={closeDisabled}

              />
              <Modal
                show={responseUrlModal}
                modalBody={responseUrlModalBody}
                modalHeader={responseUrlModalHeader}
                closeModal={closeModal}
                modalLoader={modalLoader}
                closeDisabled={closeDisabled}

              />
              <Modal
                show={quetionShowModal}
                modalBody={quetionShowModalBody}
                modalHeader={quetionShowModalHeader}
                closeModal={closeModal}
              />
              <Modal
                show={aiLastModal}
                modalBody={aiLastModalBody}
                modalHeader={aiLastModalHeader}
                closeModal={closeModal}
              />
            </>

          </>
        }
      </div>
    </>
  )
}
export default AiboatVideoSection;